import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { setExercise, showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast } from '../utils/Utils';
import SideBarListStyles from '../../styles/SideBarListStyle';
import ShowProgress from '../ui/Backdrop';
import FloatButton from '../sidebar/FloatButton';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ExerciseCatPopup } from './ExerciseCatPopup';
import { useExerciseCategory } from './hooks/useExerciseCategory';

export function SidebarListAI(props) {
  const { filterArray } = props;
  const dispatch = useDispatch();
  const classes = SideBarListStyles();

  const { fetchAllCategories, handleListItemClick } = useExerciseCategory();

  const selectedCat = useSelector((state) => state.aiRoleplayData.selectedCategory || {});

  const [isOpenPopup, setIsOpenPopup] = useState(false);

  const value = props.value ?? 0;

  useEffect(() => {
    fetchAllCategories();
  }, []);

  const fetchExercise = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(apiEndpoints.AI_EXERCISE.replace('ID', selectedCat.id));
      dispatch(setExercise(res));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (selectedCat?.id) {
      fetchExercise();
    }
  }, [selectedCat]);

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    myRefs[selectedCat.id]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [selectedCat, filterArray]);

  const getExerciseCount = (count) => {
    const suffix = count > 1 ? 'Exercises' : 'Exercise';
    return `${count} ${suffix}`;
  };

  const addNewExerciseCat = () => {
    setIsOpenPopup(true);
  };

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray?.map((data) => (
          <div key={data.id} className={selectedCat.id === data.id ? classes.highlightItem : ''}>
            <ListItem
              id={`Item${data.id}`}
              key={data.id}
              button
              selected={selectedCat.id === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data)}
              ref={myRefs[data.id]}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`${
                        selectedCat.id === data.id ? classes.listTextSelected : classes.listTextNonSelected
                      }`}
                    >
                      {data.name}
                    </p>
                    <p
                      style={{
                        fontSize: '12px',
                        marginTop: '-10px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      {getExerciseCount(data.exerciseCount)}
                    </p>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={18} onAddNewExerciseCat={addNewExerciseCat} />
      {isOpenPopup && <ExerciseCatPopup isOpen={isOpenPopup} setIsOpen={setIsOpenPopup} />}
      <ShowProgress />
    </div>
  );
}
